/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHiddenLine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M8.293 2.293A1 1 0 0 1 9 2h12a1 1 0 0 1 1 1v12a1 1 0 0 1-.293.707l-6 6A1 1 0 0 1 15 22H3a1 1 0 0 1-1-1V9a1 1 0 0 1 .293-.707zM9.414 4l-4 4h9.172l4-4zM20 5.414l-4 4v9.172l4-4zM14 20V10H4v10z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgHiddenLine as HiddenLine };
